package ui.showcase.showcases

import adapters.Api
import csstype.Properties
import csstype.PropertiesBuilder
import emotion.react.css
import helpers.PropsWithCss
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.useEffectOnce
import react.useState
import ru.malygin.dto.FindTeachersItemDto
import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.ApiReturns
import ru.malygin.myConst.TeacherPlaces
import ui.new_ui.components.card_handler.CardHandler
import ui.new_ui.components.card_item.CardItem
import ui.new_ui.components.card_item.CardStyles
import ui.new_ui.components.divider.DividerHorizontal
import ui.new_ui.components.find_teacher_page.FindTeacherHelpers
import ui.new_ui.components.loaders.linear_loaders.LinearLoader
import ui.new_ui.components.move_up.MoveUp
import ui.new_ui.components.search.Search
import ui.new_ui.screen_settings.CentredScreenComponent
import ui.themePlusContext.ToastData
import ui.themePlusContext.useToastContext
import web.cssom.TextAlign
import web.cssom.pct
import web.cssom.px

val FindTeacherPage = FC {
    val toast = useToastContext()

    var data by useState<List<FindTeachersItemDto>>(emptyList())
    var someError by useState<String?>(null)

    fun setError(mess:String? = null) {
        if (mess.isNullOrEmpty()){
            someError = mess
        }else{
            someError = mess
            toast.open(
                ToastData(
                    message = mess
                )
            )
        }
    }

    useEffectOnce {
        when(val returned = Api().getFindTeacherData()){
            is ApiReturns.Error -> setError(returned.code.message)
            is ApiReturns.SuccessForFindTeacher -> data = returned.data
            else -> Unit
        }
    }

    CentredScreenComponent{

        ReactHTML.div{
            css {
                width = 100.pct
                maxWidth = 920.px
            }

            MoveUp()

            when{
                data.isEmpty()-> FindTeacherEmpty()
                data.isEmpty() && !someError.isNullOrEmpty() -> FindTeacherError{
                    error = someError
                }
                else -> FindTeacherList{
                    findTeachersItemDtos = data
                }
            }


        }
    }

}

private val FindTeacherEmpty = FC {
    LinearLoader()
}
private external interface FindTeacherErrorProps: Props{
    var error: String?
}
private val FindTeacherError = FC<FindTeacherErrorProps> {props->
    ReactHTML.span{
        css {
            color = CardStyles.color()
        }
        +"Ошибка ${props.error}"
    }
}



private external interface FindTeacherListProps: Props{
    var findTeachersItemDtos: List<FindTeachersItemDto>
}

private val FindTeacherList = FC<FindTeacherListProps> {props->
    var searchQuery by useState<String>("")

    Search{
        this.onUpdate = {query ->
            searchQuery = query
        }
    }

    CardHandler{

        props.findTeachersItemDtos.filter { dto_->
            dto_.name.lowercase().contains(searchQuery.lowercase())
        }.takeIf {
            it.isNotEmpty()
        }?.let {ity->
            ity.forEach { dto_->
                ReactHTML.li{

                    CardItem{
                        this.css = {
                            it.textAlign = TextAlign.left
                        }
                        ReactHTML.span{
                            css{
                                color = CardStyles.color()
                            }

                            +dto_.name
                        }
                        DividerHorizontal()
                        FindTeacherPlace{
                            css = {
                                it.color = CardStyles.color()
                            }
                            dto = dto_
                        }
                    }
                }
            }
        } ?: run {
            ReactHTML.span{
                css{
                    backgroundColor = CardStyles.backgroundColor()
                    color = CardStyles.color()
                }
                +"Ничего не найдено"
            }
        }
    }
}

private external interface FindTeacherPlaceProps: PropsWithCss{
    var dto: FindTeachersItemDto
}

private val FindTeacherPlace = FC<FindTeacherPlaceProps> {props ->
    val prefix_ = if (props.dto.name.split(" ")[0].endsWith('а', true)) "Была" else "Был"

    ReactHTML.div{
        when(val place = props.dto.places){
            is TeacherPlaces.After -> FindTeacherHelpers.FindTeacherPlacesAfter{
                css = props.css
                prefix = prefix_
                after = getClassRoom(props.dto.itemsDto, place.afterId)?.roomNum ?: "_=_"
                time = (getClassRoom(props.dto.itemsDto, place.afterId)?.lessonStart ?: "_=_") +"-"+ (getClassRoom(props.dto.itemsDto, place.afterId)?.lessonEnd ?: "_=_")
            }
            is TeacherPlaces.Before -> FindTeacherHelpers.FindTeacherPlacesBefore{
                css = props.css
                prefix = prefix_
                before = getClassRoom(props.dto.itemsDto, place.beforeId)?.roomNum ?: "_=_"
                time = (getClassRoom(props.dto.itemsDto, place.beforeId)?.lessonStart ?: "_=_") +"-"+ (getClassRoom(props.dto.itemsDto, place.beforeId)?.lessonEnd ?: "_=_")
            }
            is TeacherPlaces.Between -> FindTeacherHelpers.FindTeacherPlacesBetween{
                css = props.css
                prefix = prefix_
                was = getClassRoom(props.dto.itemsDto, place.beforeId)?.roomNum ?: "_=_"
                timeWas = (getClassRoom(props.dto.itemsDto, place.beforeId)?.lessonStart ?: "_=_") +"-"+ (getClassRoom(props.dto.itemsDto, place.beforeId)?.lessonEnd ?: "_=_")
                be = getClassRoom(props.dto.itemsDto, place.afterId)?.roomNum ?: "_=_"
                timeBe = (getClassRoom(props.dto.itemsDto, place.afterId)?.lessonStart ?: "_=_") +"-"+ (getClassRoom(props.dto.itemsDto, place.afterId)?.lessonEnd ?: "_=_")
            }
            is TeacherPlaces.In -> FindTeacherHelpers.FindTeacherPlacesIn{
                css = props.css
                prefix = prefix_
                `in` = getClassRoom(props.dto.itemsDto, place.id)?.roomNum ?: "_=_"
                time = (getClassRoom(props.dto.itemsDto, place.id)?.lessonStart ?: "_=_") +"-"+ (getClassRoom(props.dto.itemsDto, place.id)?.lessonEnd ?: "_=_")
            }
            TeacherPlaces.None -> FindTeacherHelpers.FindTeacherPlacesNone{
                css = props.css
            }
        }
    }


}

private fun getClassRoom(
    dto_U: List<MainScheduleItemDto>?,
    id_: Int
): MainScheduleItemDto? {
    return dto_U?.find {
        it.id == id_
    }
}